import { tickerItems } from "@/mocks/homeData";

export default function Ticker() {
  const doubled = [...tickerItems, ...tickerItems];
  return (
    <div className="bg-primary-600 text-background-50">
      <div className="mx-auto flex max-w-7xl items-center gap-3 overflow-hidden px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 py-2 text-xs font-semibold tracking-wide">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
          </span>
          今日瓜点
        </span>
        <div className="relative flex h-9 flex-1 items-center overflow-hidden">
          <div className="animate-marquee flex shrink-0 items-center gap-10 whitespace-nowrap pl-4 text-xs md:text-sm">
            {doubled.map((t, i) => (
              <span key={i} className="inline-flex items-center gap-2 opacity-95">
                <i className="ri-flashlight-fill text-accent-300 text-[11px]" />
                {t}
              </span>
            ))}
          </div>
        </div>
        <span className="hidden shrink-0 items-center gap-1.5 py-2 pl-3 text-xs text-background-100/90 md:flex">
          <i className="ri-time-line" />
          每 10 分钟更新
        </span>
      </div>
    </div>
  );
}